import { userConstants } from './../constants/user.constants';

let user = sessionStorage.getItem('user');
const initialState = user ? { user, isLoading: false } : {};

export function Insanction(state = initialState, action) {
  
  console.log("inside Insanction", action)
  switch (action.type) {
    case userConstants.INSANCTION_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.INSANCTION_SUCCESS:
      const {res} = action
        console.log("Action", action)
      return {
        res,
        isLoading : false
      };
    case userConstants.INSANCTION_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}